var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatherText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 162.37,
    height: 40,
    viewBox: "0 0 162.37 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34,39.49V15.68H0v-3.63h4.34v-2.82c0-2.94.79-5.22,2.36-6.82,1.57-1.61,3.8-2.41,6.68-2.41,1.08,0,2.16.14,3.22.43l-.25,3.78c-.8-.15-1.64-.23-2.54-.23-1.52,0-2.7.45-3.53,1.34s-1.24,2.17-1.24,3.83v2.9h5.87v3.63h-5.87v23.82h-4.7Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.48,40c-3.72,0-6.75-1.22-9.09-3.67s-3.5-5.71-3.5-9.8v-.86c0-2.72.52-5.15,1.56-7.29,1.04-2.14,2.5-3.81,4.37-5.02,1.87-1.21,3.9-1.81,6.08-1.81,3.57,0,6.35,1.18,8.33,3.53,1.98,2.35,2.97,5.72,2.97,10.1v1.95h-18.61c.07,2.71.86,4.89,2.37,6.56s3.44,2.5,5.78,2.5c1.66,0,3.06-.34,4.21-1.01,1.15-.68,2.16-1.57,3.02-2.69l2.87,2.23c-2.3,3.53-5.75,5.3-10.36,5.3ZM30.9,15.4c-1.9,0-3.49.69-4.77,2.07-1.29,1.38-2.08,3.31-2.39,5.8h13.76v-.36c-.14-2.38-.78-4.23-1.93-5.54-1.15-1.31-2.71-1.97-4.67-1.97Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.59,39.49c-.27-.54-.49-1.5-.66-2.89-2.18,2.27-4.79,3.4-7.82,3.4-2.71,0-4.93-.76-6.67-2.3s-2.6-3.47-2.6-5.82c0-2.86,1.09-5.08,3.26-6.66s5.23-2.37,9.18-2.37h4.57v-2.16c0-1.64-.49-2.95-1.47-3.92-.98-.97-2.43-1.46-4.34-1.46-1.68,0-3.08.42-4.21,1.27-1.13.85-1.7,1.87-1.7,3.07h-4.72c0-1.37.49-2.69,1.46-3.97.97-1.28,2.29-2.29,3.96-3.03,1.67-.74,3.5-1.12,5.5-1.12,3.17,0,5.65.79,7.44,2.37,1.79,1.58,2.73,3.76,2.79,6.53v12.63c0,2.52.32,4.52.96,6.01v.41h-4.93ZM56.8,35.92c1.47,0,2.87-.38,4.19-1.14s2.28-1.75,2.87-2.97v-5.63h-3.68c-5.75,0-8.63,1.68-8.63,5.05,0,1.47.49,2.62,1.47,3.45.98.83,2.24,1.24,3.78,1.24Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.29,5.4v6.65h5.13v3.63h-5.13v17.04c0,1.1.23,1.93.69,2.48s1.24.83,2.34.83c.54,0,1.29-.1,2.23-.3v3.78c-1.24.34-2.44.5-3.61.5-2.1,0-3.68-.63-4.75-1.9s-1.6-3.07-1.6-5.4V15.68h-5v-3.63h5v-6.65h4.7Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6,15.37c2.08-2.55,4.79-3.83,8.12-3.83,5.81,0,8.73,3.27,8.79,9.82v18.14h-4.7v-18.16c-.02-1.98-.47-3.44-1.36-4.39-.89-.95-2.27-1.42-4.15-1.42-1.52,0-2.86.41-4.01,1.22s-2.05,1.88-2.69,3.2v19.56h-4.7V.53h4.7v14.84Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M132.95,40c-3.72,0-6.75-1.22-9.09-3.67s-3.5-5.71-3.5-9.8v-.86c0-2.72.52-5.15,1.56-7.29,1.04-2.14,2.5-3.81,4.37-5.02,1.87-1.21,3.9-1.81,6.08-1.81,3.57,0,6.35,1.18,8.33,3.53,1.98,2.35,2.97,5.72,2.97,10.1v1.95h-18.61c.07,2.71.86,4.89,2.37,6.56s3.44,2.5,5.78,2.5c1.66,0,3.06-.34,4.21-1.01,1.15-.68,2.16-1.57,3.02-2.69l2.87,2.23c-2.3,3.53-5.75,5.3-10.36,5.3ZM132.36,15.4c-1.9,0-3.49.69-4.77,2.07-1.29,1.38-2.08,3.31-2.39,5.8h13.76v-.36c-.14-2.38-.78-4.23-1.93-5.54-1.15-1.31-2.71-1.97-4.67-1.97Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M162.37,16.26c-.71-.12-1.48-.18-2.31-.18-3.08,0-5.17,1.31-6.27,3.93v19.48h-4.7V12.05h4.57l.08,3.17c1.54-2.45,3.72-3.68,6.55-3.68.91,0,1.61.12,2.08.36v4.36Z",
    fill: "#fff",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherText);
export default __webpack_public_path__ + "static/media/FeatherText.262448c50f3f3ea600afaa2aaf0ba57e.svg";
export { ForwardRef as ReactComponent };